import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-learning-header',
    templateUrl: './learning-header.component.html',
    styleUrls: ['./learning-header.component.scss']
})
export class LearningHeaderComponent {
    public selected = 0;

    public date = '';

    constructor(private router: Router, private ls: LocalStorageService) { }

    categorySelected(name: string, id: number) {
        this.ls.setLS('Category', name);

        if (!id) return;
        this.router.navigate(['learning/article', id]);
    }
}
